import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DsTextSize } from '@design-system/ds-text/types/ds-text-size.type';
import { DsTextTheme } from '@design-system/ds-text/types/ds-text-theme.type';
import { DsTextWeight } from '@design-system/ds-text/types/ds-text-weight.type';
import { DsTextFontSettings } from '@design-system/ds-text/interfaces/ds-text-font-settings.interface';

@Component({
  selector: 'ds-text',
  standalone: true,
  imports: [NgIf, NgClass],
  templateUrl: './ds-text.component.html',
  styleUrls: ['./ds-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsTextComponent {
  /**
   * Controls typography size variant.
   *
   * @default 'md'
   */
  @Input() size: DsTextSize = 'md';

  /**
   * Controls typography weight variant.
   *
   * @default 'regular'
   */
  @Input() weight: DsTextWeight = 'medium';

  /**
   * Controls text color theme.
   *
   * @default 'secondary'
   */
  @Input() theme: DsTextTheme = 'secondary';

  /**
   * Optional plain text content.
   * If not provided, projected content is rendered.
   */
  @Input() text: string | null = null;

  /**
   * Optional color override for text.
   * If not provided, `--ds-text-primary-color` is used.
   */
  @Input() color: string | null = null;

  /**
   * Optional uncommon typography overrides.
   */
  @Input() fontSettings: DsTextFontSettings | null = null;
}
